import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class LmJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.LM;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_LM;
    protected readonly showComparatorSelection = false;
    protected readonly showDetailsButton = false;
    protected readonly wordings = {
        mainTitle: 'Vous avez choisi la B&YOU Pure fibre. On teste votre éligibilité ?',
        noFiber: "En attendant l'arrivée de la fibre...",
        results: {
            [TECHNOLOGY.FTTH]: 'Bonne nouvelle, vous pouvez profiter des offres B&YOU Pure fibre !',
        },
    };
    protected readonly tracking = {
        page: 'Eligibilite_test',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_Bbox',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        alertTitle: 'La fibre est nécessaire pour profiter des offres B&YOU Pure fibre',
        alertDescription: "En attendant d'être éligible, vous pouvez voir les offres disponibles chez vous.",
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Popin_adresse_non_eligible_bboxlm',
            nomClic: 'Voir_les_offres',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_bboxlm',
            nomClic: 'Eligibilite_ko_bboxlm',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest,
    };
    protected readonly technologies = [TECHNOLOGY.FTTH];
    protected readonly referrerConfigKey = 'lmReferrers';
    protected readonly accessKeyPartnerConfigKey = 'lmPartner';
    protected readonly shouldCheckCommercialPartner = true;
    protected readonly extraCmsBlockByTab = {};
}
